import {
  LEGACY_PAYMENT_METHOD_GATEWAY,
  PAYMENT_METHOD_ENUM,
  PAYMENT_METHOD_GATEWAY,
} from 'modules/common/constants/payment-method.enums';
import { IPaymentData, IPaymentRequest } from 'modules/common/interfaces/payment';
import { clsx } from 'clsx';

export const getPaymentGatewayImage = (gateway: PAYMENT_METHOD_GATEWAY, className?: string) => {
  switch (gateway) {
    case PAYMENT_METHOD_GATEWAY.ENZONA:
      return (
        <img
          alt={gateway}
          width={48}
          height={48}
          src={'/images/payment-gateways/enzona.png'}
          className={clsx('object-contain', className)}
        />
      );
    case PAYMENT_METHOD_GATEWAY.TM:
      return (
        <img
          alt={gateway}
          width={48}
          height={48}
          src={'/images/payment-gateways/transfermovil.png'}
          className={clsx('object-contain', className)}
        />
      );
    case PAYMENT_METHOD_GATEWAY.TROPIPAY:
      return (
        <img
          alt={gateway}
          width={155}
          height={48}
          src={'/images/payment-gateways/tropipay.png'}
          className={clsx('object-scale-down', className)}
        />
      );
    case PAYMENT_METHOD_GATEWAY.LABERINTO:
      return (
        <img
          alt={gateway}
          width={143}
          height={30}
          src={'/images/payment-gateways/credit-cards.webp'}
          className={clsx('object-scale-down', className)}
        />
      );
    default:
      return null;
  }
};

export const getSmallPaymentGatewayImage = (gateway: PAYMENT_METHOD_GATEWAY) => {
  switch (gateway) {
    case PAYMENT_METHOD_GATEWAY.ENZONA:
      return <img alt={gateway} width={48} height={48} src={'/images/payment-gateways/enzona.png'} />;
    case PAYMENT_METHOD_GATEWAY.TM:
      return <img alt={gateway} width={48} height={48} src={'/images/payment-gateways/transfermovil.png'} />;
    case PAYMENT_METHOD_GATEWAY.TROPIPAY:
      return <img alt={gateway} width={48} height={44} src={'/images/payment-gateways/tropipay-small.png'} />;
    case PAYMENT_METHOD_GATEWAY.LABERINTO:
      return <img alt={gateway} width={143} height={30} src={'/images/payment-gateways/credit-cards.webp'} />;
    default:
      return null;
  }
};

export const transformPayment = (payment: IPaymentData) => {
  if (payment?.paymentGateway) {
    let gateway = null;
    if (payment?.paymentGateway === LEGACY_PAYMENT_METHOD_GATEWAY.transfermovil) {
      gateway = PAYMENT_METHOD_GATEWAY.TM;
    } else if (payment?.paymentGateway === LEGACY_PAYMENT_METHOD_GATEWAY.tropipay) {
      gateway = PAYMENT_METHOD_GATEWAY.TROPIPAY;
    }
    return {
      ...payment,
      gateway,
    } satisfies IPaymentData;
  }
  return payment;
};

export const requireExternalActions = (gateway?: PAYMENT_METHOD_GATEWAY | null) => {
  return !!gateway && (gateway === PAYMENT_METHOD_GATEWAY.TROPIPAY || gateway === PAYMENT_METHOD_GATEWAY.LABERINTO);
};

export const getGatewayError = (data?: IPaymentRequest) => {
  if (data?.raw?.status === 'FAIL') {
    return 'errors:gatewayConnectionFailed';
  }
  return null;
};

export const getDefaultPaymentMethod = (gateway?: PAYMENT_METHOD_GATEWAY) => {
  switch (gateway) {
    case PAYMENT_METHOD_GATEWAY.TROPIPAY:
      return PAYMENT_METHOD_ENUM.TROPIPAY;
    case PAYMENT_METHOD_GATEWAY.TM:
    case PAYMENT_METHOD_GATEWAY.LABERINTO:
      return PAYMENT_METHOD_ENUM.CREDIT_CARD;
    default:
      return null;
  }
};
